import React, { useCallback, useRef } from 'react';
import DisplayFilesByLeadPopupContext, {
  FileAccessPopupState,
} from './DisplayFilesByLeadPopup.context';

type DisplayFilesByLeadPopupProviderProps = {
  children: React.ReactNode;
};

const DisplayFilesByLeadPopupProvider: React.FC<
  DisplayFilesByLeadPopupProviderProps
> = ({ children }) => {
  const popupStateRef = useRef<Record<string, FileAccessPopupState>>({});

  const getPopupState = useCallback(
    (leadId: string) => popupStateRef.current[leadId],
    [],
  );

  const setPopupState = useCallback(
    (leadId: string, next: FileAccessPopupState) => {
      if (!next?.state) {
        delete popupStateRef.current[leadId];
        return;
      }

      popupStateRef.current[leadId] = next;
    },
    [],
  );

  return (
    <DisplayFilesByLeadPopupContext.Provider
      value={{
        getPopupState,
        setPopupState,
      }}
    >
      {children}
    </DisplayFilesByLeadPopupContext.Provider>
  );
};

export default DisplayFilesByLeadPopupProvider;
